import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  FEED_TAB_PARAM,
  readFeedTabToken,
  resolveFeedTabToken,
} from "./feedConstants";

const tabToViewFlags = (tab) => ({
  showingMatches: tab === "matches",
  showingBattles: tab === "battles",
  showingFlex: tab === "flex",
  showingAsk: tab === "ask",
});

export function useFeedTab({ initialTab, onTabActivate, enabled = true }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const initial = resolveFeedTabToken(initialTab);
  const activeTab = enabled ? readFeedTabToken(searchParams) : initial;
  const { showingMatches, showingBattles, showingFlex, showingAsk } =
    tabToViewFlags(activeTab);

  useEffect(() => {
    if (!enabled) return;
    onTabActivate?.(activeTab);
  }, [enabled, activeTab, onTabActivate]);

  const setFeedTab = useCallback(
    (tabId) => {
      const tab = resolveFeedTabToken(tabId);
      const next = new URLSearchParams(searchParams);
      if (!tab) {
        next.delete(FEED_TAB_PARAM);
      } else {
        next.set(FEED_TAB_PARAM, tab);
      }
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return {
    activeTab,
    showingMatches,
    showingBattles,
    showingFlex,
    showingAsk,
    setFeedTab,
  };
}
